import { Injectable } from '@angular/core';
import {
  UiSession,
} from '@brighthub/uisession';
import { Observable } from 'rxjs';
import { BrightNavOmniSearchProvider } from '@brighthub/brightnav-search';
import { OmniSearchResult } from '@brighthub/search';
import {
  ConversationSearchResultWrapperComponent
} from './conversation-search-result-wrapper/conversation-search-result-wrapper.component';
import { ConversationService } from './conversation.service';
import { BRIGHTNAV_ADMIN_OKTA_GROUP } from '@brighthub/admin-contract';

@Injectable({
  providedIn: 'root'
})
export class ConversationSearchProvider extends BrightNavOmniSearchProvider<UiSession> {

  id = 'conversation';
  label = 'Search for Conversation';
  override description = 'Search for a conversation by id';
  override shortcut = '@conversation';
  rolesAllowed = [BRIGHTNAV_ADMIN_OKTA_GROUP];

  /**
   * Explicit ctor + `super()` — see {@link EmployeeSearchProvider}; same subclass DI reliability.
   */
  constructor(private readonly conversationSearchSvc: ConversationService) {
    super();
  }

  search(conversationId: string): Observable<OmniSearchResult<UiSession>[]> {
    return this.conversationSearchSvc.queryConversationById(conversationId);
  }

  loadComponent = async () => ConversationSearchResultWrapperComponent;

}
